import { linkedinConstants } from '@constants/linkedin';
import { linkedinIntegrationService } from '@services';

export const linkedinActions = {
    get,
    reset,
};

function get(integrationId = null) {
    return dispatch => {
        dispatch(request());
        return linkedinIntegrationService.getTargets(integrationId).then(
            data => {
                dispatch(success(data));
                return data;
            },
            error => dispatch(failure(error)),
        );
    };
}

function request() {
    return { type: linkedinConstants.LINKEDIN_TARGETS_REQUEST };
}

function success(data) {
    return { type: linkedinConstants.LINKEDIN_TARGETS_SUCCESS, data };
}

function failure(message) {
    return { type: linkedinConstants.LINKEDIN_TARGETS_ERROR, message };
}

function reset() {
    return { type: linkedinConstants.LINKEDIN_TARGETS_RESET };
}
